const functionnal = {
    existy: function (x) {
        return x !== null && x !== undefined;
    },
    curry1: function (fun) {
        return function (arg1, ..._) {
            return fun(arg1);
        };
    },
    curry2: function (fun) {
        return function (second) {
            return function (first) {
                return fun(first, second);
            };
        };
    },
    curry3: function (fun) {
        return function (third) {
            return function (second) {
                return function (first) {
                    return fun(first, second, third);
                };
            };
        };
    },
    curry4: (fun) => (fourth) => (third) => (second) => (first) => fun(first, second, third, fourth),
    always: function () {
        return true;
    },
    not: function (fun) {
        return function (...args) {
            return !fun(...args);
        };
    },
    validateEachPredicate: function (item, predicatesArray) {
        return predicatesArray.reduce((answer, cond) => {
            return cond(item) && answer;
        }, true);
    },
    multiPredicatesToUniquePredicate: function (predicatesArray) {
        var self = this;
        return function (item) {
            return self.validateEachPredicate(item, predicatesArray);
        };
    },
};
export default functionnal;
//# sourceMappingURL=functionnal.js.map